import { PropsWithChildren, useState, useRef, CSSProperties, ReactNode } from 'react'
import css from './tooltip.module.css'

export interface ITooltipProps {
  text: string | ReactNode
  position?: 'top' | 'bottom' | 'left' | 'right' | 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'
  delay?: number
  active?: boolean
  style?: CSSProperties
  wrapperStyle?: CSSProperties
}

const ToolTip = (props: PropsWithChildren<ITooltipProps>) => {
  const [visible, setVisible] = useState(false)
  const timeoutRef = useRef<number>(null)

  const showTooltip = () => {
    timeoutRef.current = setTimeout(() => setVisible(true), props.delay || 300)
  }

  const hideTooltip = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    setVisible(false)
  }

  return (
    <div
      className={css.tooltipWrapper}
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
      style={props.wrapperStyle}
    >
      {props.children}
      {visible && props.active !== false && props.text && (
        <div style={props.style} className={`${css.tooltip} ${css[props.position || 'top']} text-nm`}>
          {props.text}
        </div>
      )}
    </div>
  )
}

export default ToolTip
